import { defineComponent as _defineComponent } from 'vue'

import Icon from "@/components/widgets/icons/Icon.vue"
import { ScopeServiceFragmentFragment } from "@/gql"
import type { ProjectDetailsForm } from "./types"
import { useUtilities } from "@/hooks/useUtilities"
import Header3 from "@/components/widgets/typography/Header3.vue"
import ScopeSummary from "@/components/missions/Scope/ScopeSummary/ScopeSummary.vue"
import { useNewProjectContext } from "./context/useNewProjectContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
    service: null,
    form: null,
    isSubmitting: { type: Boolean }
  },
  emits: ["goto-next", "goto-prev"],
  setup(__props: any) {





const { formatDate } = useUtilities()

const { isStaff } = useNewProjectContext()

return { __sfc: true,formatDate, isStaff, Icon, Header3, ScopeSummary }
}

})